<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ oopt.transName }} > {{ $t('Заявки на квоты') }}</h1>
    <div class="my-organization">
      <div class="quotas-pg bgw-pdg-20">
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <Menu :ooptId="oopt.id" />
            <br/>
            <div class="add-npa-row">
              <v-btn class="v-btn btn-add-category" @click="goToCreate()">
                {{ $t('Создать заявку на квоту') }}
              </v-btn>
            </div>
          </div>
        </div>
        <div class="table-overflow">
          <table class="table-full">
            <thead>
            <tr>
              <td class="td-num">№</td>
              <td>{{ $t('Год') }}</td>
              <td>
                <div class="sort-flex">
                  {{ $t('Данные заявки') }}
                  <a @click="sort('date')" class="sort-btn sort-blue">
                    <v-icon v-if="sortParams.field == 'date' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                    <v-icon v-else>arrow_drop_down</v-icon>
                  </a>
                </div>
              </td>
              <td>
                <div class="sort-flex">
                  {{ $t('Статус и дата присвоения') }}
                  <a @click="sort('status')" class="sort-btn sort-blue">
                    <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                    <v-icon v-else>arrow_drop_down</v-icon>
                  </a>
                </div>
              </td>
              <td colspan="2" class="text-center">{{ $t('Данные ответа на заявку') }}</td>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(quotaApplication, i) in data" :key="i"
                  :class="{ unread: !quotaApplication.quotaApplicationView }">
                <td class="td-num">{{ i + 1 }}</td>
                <td>{{ quotaApplication.year }}</td>
                <td>
                  <router-link tag="a"
                               :to="{ name: 'quota-view', params: { id: quotaApplication.id } }"
                  >
                    {{ new Date(quotaApplication.date) | dateFormat('DD.MM.YYYY') }}
                  </router-link>
                </td>
                <td>
                  <span>{{ quotaApplication.status }}</span>
                  <template v-if="quotaApplication.lastHistory">
                    <span>{{ new Date(quotaApplication.lastHistory.date) | dateFormat('DD.MM.YYYY HH:mm') }}</span>
                    <v-menu
                      v-if="quotaApplication.lastHistory.comment"
                      v-model="commentDialog"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on">{{ $t('Комментарии') }}</a>
                      </template>
                      <v-list dense>
                        <v-list-item
                        >
                          {{ quotaApplication.lastHistory.comment }}
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </td>
                <td class="td-colspan-file-equal">
                  <AllocateQuotaModal :allocatedQuotas="quotaApplication.allocatedQuotas"/>
                </td>
                <td class="td-colspan-file-equal">
                  <p v-if="quotaApplication.fullAnswerFilePath">
                    <template
                      v-if="checkFileExist(quotaApplication.answerFileExtension)"
                    >
                      <a
                        @click="previewDocumentDialog(i, true)"
                      >{{ $t('Файл') }}</a>
                      <v-dialog
                        v-model="previewDocsModal[i]"
                        max-width="1200"
                      >
                        <v-card class="modal">
                          <div class="modal-head">
                            {{ $t('Файл') }}
                            <v-btn
                              color="modal-close"
                              @click="previewDocumentDialog(i, false)"
                            >
                              <img src="@/assets/img/close-icon.png" alt="icon">
                            </v-btn>
                          </div>
                          <div class="modal-body">
                            <VueDocPreview
                              :value="backUrl + quotaApplication.fullAnswerFilePath"
                              type="office"
                            />
                          </div>
                        </v-card>
                      </v-dialog>
                    </template>
                    <template v-else>
                      <a
                        :href="backUrl + quotaApplication.fullAnswerFilePath"
                        target="_blank"
                      >{{ $t('Файл') }}</a>
                    </template>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="page"
          :length="paginationData.pageCount"
          total-visible="10"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Menu from '@/components/quota/Menu'
import Quota from '@/model/quota'
import VueDocPreview from 'vue-doc-preview'
import AllocateQuotaModal from '@/components/quota/AllocateQuotasModal'

export default {
  components: {
    Menu,
    VueDocPreview,
    AllocateQuotaModal
  },
  data: () => ({
    search: {},
    page: 1,
    paginationData: {},
    data: [],
    breadcrumbs: [],
    backUrl: process.env.VUE_APP_BACK_URL,
    sortParams: {
      field: 'date',
      order: 'DESC'
    },
    oopt: {},
    commentDialog: false,
    previewDocsModal: []
  }),
  watch: {
    page () {
      this.ooptQuotaApplicationList(false)
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getOoptQuotaApplicationListData(this.$route.params.id)
        .then((response) => {
          this.oopt = response.data.oopt
          this.ooptQuotaApplicationList()
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
          this.generateBreadcrumbs()
        })
    },
    ooptQuotaApplicationList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      Quota.listQuotaApplicationByOopt(this.$route.params.id, this.search).then((response) => {
        this.data = response.data.items
        this.paginationData = response.data.paginationData
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.ooptQuotaApplicationList()
    },
    goToCreate () {
      this.$router.push({
        name: 'society-quota-create',
        params: {
          id: this.$route.params.id
        }
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Заявки на квоты'),
          disabled: true
        }
      ]
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    }
  }
}
</script>

<style scoped>

</style>
